import clsx from "clsx";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  full?: boolean;
  color?: "primary" | "secondary" | "danger";
  variant?: "primary" | "secondary" | "danger";
}

export default function Button({
  children,
  full = true,
  color = "primary",
  variant,
  className,
  ...props
}: ButtonProps) {
  const base =
    "px-4 py-3 min-h-[44px] rounded-lg font-semibold text-white active:scale-[0.98] transition-all duration-200 touch-target";

  const actualColor = variant || color;

  const colors = {
    primary: "bg-primary hover:bg-primaryDark active:bg-primaryDark",
    secondary: "bg-gray-800 hover:bg-gray-700 active:bg-gray-900",
    danger: "bg-red-500 hover:bg-red-600 active:bg-red-700",
  };

  return (
    <button
      className={clsx(base, colors[actualColor], full && "w-full", className)}
      {...props}
    >
      {children}
    </button>
  );
}
